module.exports = __webpack_public_path__ + "img/alfa_romeo.ec728377.png";